module.exports = __webpack_public_path__ + "static/media/dana-regular.64ade51a.woff";